import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const CoursesRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const courseKey = Cookies.get("courseKey");

    if (courseKey) {
      navigate(`/courses/${courseKey}`, { replace: true });
    } else {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="loading-container">
      <div className="loading-spinner">Loading course...</div>
    </div>
  );
};

export default CoursesRedirect;
